import PropTypes from 'prop-types';
import React from 'react';

import styles from './DividerWithText.css';

import localize from 'components/Localize/Localize';

import translations from './translations';

class DividerWithText extends React.Component {
  render() {
    const text = this.props.text || this.props.t.or;

    return (
      <div className={styles[`divider`]}>
        <div className={styles[`spacer`]} />
        <div className={styles[`text`]}>
          {text}
        </div>
        <div className={styles[`spacer`]} />
      </div>
    );
  }
}

DividerWithText.propTypes = {
  t: PropTypes.shape({
    or: PropTypes.string.isRequired,
  }).isRequired,
  text: PropTypes.string,
};

export default localize(DividerWithText, translations);
